import * as React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isVisible: boolean;
}

function ClickMe({ isVisible, ...props }: Props) {
  return (
    <Wrapper {...props} data-is-hidden={!isVisible}>
      <Arrow />
      <ClickMeTxt
        alt="Click me"
        src="/images/color-shifting/click-me.png"
      />
    </Wrapper>
  );
}

function Arrow() {
  return (
    <Svg
      width="15"
      height="43"
      viewBox="0 0 15 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.23024 41.3617C3.8777 41.7868 3.93654 42.4172 4.36166 42.7698C4.78679 43.1223 5.41721 43.0635 5.76976 42.6383L4.23024 41.3617ZM1 0.5C0.447715 0.5 0 0.947715 0 1.5V10.5C0 11.0523 0.447715 11.5 1 11.5C1.55228 11.5 2 11.0523 2 10.5V2.5H10C10.5523 2.5 11 2.05228 11 1.5C11 0.947715 10.5523 0.5 10 0.5H1ZM5 42L5.76976 42.6383C14.4482 32.1731 15.328 23.4432 12.9478 16.3686C10.6091 9.41755 5.16654 4.25232 1.70711 0.792893L1 1.5L0.292893 2.20711C3.83346 5.74768 8.89088 10.5824 11.0522 17.0064C13.172 23.3068 12.5518 31.3269 4.23024 41.3617L5 42Z"
        fill="white"
      />
    </Svg>
  );
}

const Wrapper = styled.div`
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  width: fit-content;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  pointer-events: none;
  opacity: 0.5;
  transition: opacity 200ms ease-in-out;

  button:hover + & {
    opacity: 1;
  }

  &[data-is-hidden='true'] {
    opacity: 0 !important;
  }

  @media (max-width: 40.125rem) {
    display: none;
  }
`;

const ClickMeTxt = styled.img`
  width: ${164 / 2}px;
  height: ${34 / 2}px;
`;

const Svg = styled.svg`
  align-self: flex-end;
  margin-right: 8px;
  display: block;
  overflow: visible;
`;

export default ClickMe;
